import React from 'react';
import VBControlEnd from './vbControlEnd';
import { CssInput } from './vbCssComponents';

class VBInput extends React.Component {
    constructor(props) {
        super();
        
        this.state = {
            value: props.initial ? props.initial : "",
            error: null,
            hasBlurred: false,
            paddingRight: null,
        }

        this.controlEnd = React.createRef();
        this.input = React.createRef();
        this.label = React.createRef();
    }

    componentDidMount() {
        //Update the padding on the input to allow any length of suffix
        this.setState({ paddingRight: this.controlEnd.current.getWidth(), labelHeight: this.label.current.clientHeight });
    }

    setValue(value) {
        this.setState({ value: value })
    }

    onChange(e) {
        this.setState({
            value: e.target.value,
        });
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }

    onFocus(e) {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onBlur(e) {
        let error = ""
        //If validation returns a string its an error message, if null the validation passed
        if (this.props.validation) {
            error = this.props.validation(e.target.value)
        }
        this.setState({
            error: error,
            hasBlurred: true
        });
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    setValidation() {
        //Only show validation styling if the user has left the input and there is something to validate with
        if (this.props.error) { return " validation-failed"; }
        if (!this.props.validation || !this.state.hasBlurred) { return ""; }
        if (this.state.error) { return " validation-failed"; }
        if (this.state.value != "") { return " validation-ok"; }
        return "";
    }

    render() {
        
        return (
            <div className="w-full">
                <div ref={this.label} onClick={() => { this.input.current.focus() }}>
                    {this.props.label}
                </div>
                <div className="w-full inline-block relative">
                    <CssInput
                        ref={this.input}
                        onChange={this.onChange.bind(this)}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        value={this.state.value}
                        labelHeight={this.state.labelHeight+'px'}
                        className={this.props.inputClass+this.setValidation()}
                        style={Object.assign({paddingRight: this.state.paddingRight}, this.props.inputStyle)}
                        type={this.props.type}
                        step={this.props.step}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                        required={this.props.required}
                        readOnly={this.props.readOnly}
                        inputMode={this.props.inputMode}
                    />
                    {/* this ads the suffix possibility and the ok/invalid checkbox */}
                    <VBControlEnd ref={this.controlEnd} suffix={this.props.suffix} icon={this.setValidation()} />
                </div>
                <div className="supp-scarlet caption pt-1">
                    {this.props.error ? this.props.error : null}
                    {this.state.hasBlurred && !this.props.error ? this.state.error : null}
                </div>
            </div>
        );
    }
}

VBInput.defaultProps = { 
    inputClass: '', 
    type: 'text', 
    inputMode: '', 
    readOnly: false,
};

export default VBInput;